import { render, staticRenderFns } from "./CopyPaymentChangeLink.vue?vue&type=template&id=2fbb58f1"
import script from "./CopyPaymentChangeLink.vue?vue&type=script&lang=js"
export * from "./CopyPaymentChangeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports